import { createFileRoute } from "@tanstack/react-router";

import ConsumeGoogleCode from "./-components/ConsumeGoogleCode";
import WithGoogleAuth from "@/components/WithGoogleAuth";
import { GoogleAuthProvider } from "@/providers/GoogleAuthProvider";

export const Route = createFileRoute("/_app/auth/google")({
  component: GoogleAuthCallback,
});

/**
 * Not a child of `_dashboard`: this is the redirect leg of the Google OAuth
 * flow, so it renders the sign-up Google context and nothing else while the
 * code is exchanged.
 */
function GoogleAuthCallback() {
  return (
    <WithGoogleAuth>
      <GoogleAuthProvider endpoint="register">
        <ConsumeGoogleCode />
      </GoogleAuthProvider>
    </WithGoogleAuth>
  );
}
